var deviceInfo;
var hasLocalStorage;

document.addEventListener('DOMContentLoaded', function () {
    deviceInfo = DeviceDetector.parse();
    document.body.classList.add('is_' + deviceInfo.type.toLowerCase());
    hasLocalStorage = (typeof (localStorage) !== 'undefined');
    if (location.hash) {
        setTimeout(function () {
            window.scrollTo(0, 0);
        }, 1);
    }

    initContentScroller();
    initMainNavigation();
    initMainNavigationSubSections();
    initSidebarNavigation();
    initSidebarSubNavigation();
    initQuickNavigation();
    initNavigateToTop();
    initMainNavigationSelectrDropdowns();
    initTogglePageVisual();
});

window.addEventListener('resize', function () {
    initSidebarSubNavigation();
});

var contentSectionObserver = null;
function initContentScroller() {
    if (!document.querySelector('.page-content-wrapper')) { return; }
    setTimeout(updateSideNavigationOnLoad, 500);

    if (contentSectionObserver) { contentSectionObserver.disconnect(); }

    contentSectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                updateSideNavigationFromContentScroller(entry.target.id);
            }
        });
    }, { root: null, rootMargin: '-20% 0px -60% 0px', threshold: 0 });

    document.querySelectorAll('.content-section').forEach(function (el) {
        contentSectionObserver.observe(el);
    });
}

function updateSideNavigationOnLoad() {
    setTimeout(function () {
        var hasValidHash = location.hash && location.hash.substr(1).includes('section-');
        if (hasValidHash) {
            var target = location.hash.substr(1);
            var targetEl = document.getElementById(target);
            if (targetEl) { targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
            var nav = document.querySelector('nav');
            if (nav) {
                var affectedItem = nav.querySelector('[data-target=' + target + ']');
                if (affectedItem) {
                    affectedItem.classList.add('active');
                    var subNavBtn = affectedItem.closest('li').closest('ul').closest('li').querySelector('button.sub-navigation');
                    if (subNavBtn) { subNavBtn.classList.add('active'); }
                }
            }
        } else {
            var firstMenuItem = document.querySelector('nav ul.level-1 li:first-of-type');
            if (firstMenuItem) {
                var subNavBtn = firstMenuItem.querySelector('.button.sub-navigation');
                if (subNavBtn) { subNavBtn.classList.add('active'); }
                var firstSub = firstMenuItem.querySelector('ul.level-2');
                if (firstSub) {
                    firstSub.classList.add('active');
                    var firstSubItem = firstSub.querySelector('li:first-of-type .sub-navigation-level2');
                    if (firstSubItem) { firstSubItem.classList.add('active'); }
                }
            }
        }
    }, 500);
}

function updateSideNavigationFromContentScroller(contentSectionId) {
    if (window.innerWidth < 800) { return; }
    var nav = document.querySelector('nav');
    if (!nav) { return; }
    var affectedItem = nav.querySelector('[data-target=' + contentSectionId + ']');
    if (!affectedItem) { return; }
    if (affectedItem.classList.contains('active')) { return; }
    nav.querySelectorAll('.sub-navigation-level2').forEach(function (el) { el.classList.remove('active'); });
    affectedItem.classList.add('active');
    var navSubMenu = affectedItem.closest('ul.level-2');
    var navButton = navSubMenu ? navSubMenu.closest('li').querySelector('button.sub-navigation') : null;
    if (navSubMenu && !navSubMenu.classList.contains('active')) {
        nav.querySelectorAll('ul.level-2.active').forEach(function (el) { el.classList.remove('active'); });
        nav.querySelectorAll('button.sub-navigation.active').forEach(function (el) { el.classList.remove('active'); });
        navSubMenu.classList.add('active');
        if (navButton) { navButton.classList.add('active'); }
    }
}

function initMainNavigation() {
    var trigger = document.getElementById('main-navigation-toggle');
    if (!trigger) { return; }
    trigger.addEventListener('click', function () {
        var navigation = document.getElementById('main-navigation-container');
        if (!navigation) { return; }
        if (navigation.classList.contains('visible')) {
            navigation.classList.remove('visible');
            document.body.classList.remove('locked');
            var icon = trigger.querySelector('.fa');
            if (icon) { icon.classList.remove('fa-times'); icon.classList.add('fa-bars'); }
        } else {
            navigation.classList.add('visible');
            document.body.classList.add('locked');
            var icon = trigger.querySelector('.fa');
            if (icon) { icon.classList.remove('fa-bars'); icon.classList.add('fa-times'); }
        }
    });
}

function initMainNavigationSubSections() {
    document.querySelectorAll('[id^=main-navigation-button-]').forEach(function (btn) {
        btn.addEventListener('click', function () {
            btn.classList.toggle('active');
            btn.closest('li').querySelectorAll('ul').forEach(function (ul) { ul.classList.toggle('visible'); });
        });
    });
}

function initSidebarNavigation() {
    document.querySelectorAll('nav .sub-navigation').forEach(function (btn) {
        btn.addEventListener('click', function () {
            var submenu = btn.closest('li').querySelector('ul');
            if (!submenu) { return; }
            if (submenu.classList.contains('active')) {
                btn.classList.remove('active');
                submenu.classList.remove('active');
            } else {
                document.querySelectorAll('.level-2.active').forEach(function (el) { el.classList.remove('active'); });
                document.querySelectorAll('.sub-navigation.active').forEach(function (el) { el.classList.remove('active'); });
                btn.classList.add('active');
                submenu.classList.add('active');
            }
        });
    });
}

function initSidebarSubNavigation() {
    document.querySelectorAll('.sub-navigation-level2').forEach(function (el) {
        el.replaceWith(el.cloneNode(true));
    });
    document.querySelectorAll('.sub-navigation-level2').forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.stopPropagation(); e.preventDefault();
            showContentInScroller(el);
        });
    });
}

function showContentInScroller(trigger) {
    var target = trigger.dataset.target;
    var targetEl = document.getElementById(target);
    if (targetEl) { targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    trigger.closest('ul').querySelectorAll('.sub-navigation-level2').forEach(function (el) { el.classList.remove('active'); });
    trigger.classList.add('active');
}

function initQuickNavigation() {
    var qTrigger = document.getElementById('quick-navigation-trigger');
    var qItems = document.getElementById('quick-navigation-items');
    var qClose = document.getElementById('quick-navigation-close');

    if (qTrigger && qItems) {
        qTrigger.addEventListener('click', function () {
            qItems.classList.toggle('active');
        });
    }
    if (qItems) {
        qItems.querySelectorAll('a').forEach(function (a) {
            a.addEventListener('click', function (e) {
                e.preventDefault();
                var href = a.getAttribute('href');
                qItems.classList.remove('active');
                setTimeout(function () { document.location = href; }, 175);
            });
        });
    }
    if (qClose && qItems) {
        qClose.addEventListener('click', function () {
            qItems.classList.toggle('active');
        });
    }
}

function initNavigateToTop() {
    document.querySelectorAll('.to-top-trigger').forEach(function (el) {
        el.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    });
}

function initMainNavigationSelectrDropdowns() {
    var mobileDevice = false;
    Object.defineProperty(Selectr.prototype, 'mobileDevice', {
        get: function () { return mobileDevice; },
        set: function (val) { mobileDevice = val; },
        enumerable: true,
        configurable: true
    });

    var districtsEl = document.getElementById('selectr-main-navigation-stadsdelen');
    if (districtsEl) {
        var districtsDropdown = new Selectr('#selectr-main-navigation-stadsdelen', {
            defaultSelected: false,
            nativeDropdown: false,
            placeholder: 'Direct naar stadsdeel',
            searchable: true,
            messages: { noResults: 'Geen resultaten', searchPlaceholder: 'Zoek op trefwoord...' }
        });
        districtsDropdown.on('selectr.open', function () {
            var anchor = document.getElementById('scroll-anchor-neighborhoods');
            if (anchor) { anchor.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
        });
        districtsDropdown.on('selectr.select', function (option) {
            var event = new CustomEvent('stadsdeelSelected', { 'detail': {
                'stadsdeelId': option.dataset.stadsdeelId,
                'stadsdeelName': option.innerHTML,
            }});
            localStorage.navSelectedStadsdeel = JSON.stringify(event.detail);
            window.dispatchEvent(event);
            var toggle = document.getElementById('main-navigation-toggle');
            if (toggle) { toggle.click(); }
            mainNavigationSelectrDropdownSelected(option.value, districtsDropdown);
        });
    }

    var neighborhoodsEl = document.getElementById('selectr-main-navigation-kompas-neighborhoods');
    if (neighborhoodsEl) {
        var neighborhoodsDropdown = new Selectr('#selectr-main-navigation-kompas-neighborhoods', {
            defaultSelected: false,
            nativeDropdown: false,
            placeholder: 'Direct naar een wijk',
            searchable: true,
            messages: { noResults: 'Geen resultaten', searchPlaceholder: 'Zoek op trefwoord...' }
        });
        neighborhoodsDropdown.on('selectr.open', function () {
            var anchor = document.getElementById('scroll-anchor-neighborhoods');
            if (anchor) { anchor.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
        });
        neighborhoodsDropdown.on('selectr.select', function (option) {
            var event = new CustomEvent('wijkSelected', { 'detail': { 'wijkId': option.dataset.wijkId } });
            window.dispatchEvent(event);
            var toggle = document.getElementById('main-navigation-toggle');
            if (toggle) { toggle.click(); }
            mainNavigationSelectrDropdownSelected(option.value, neighborhoodsDropdown);
        });
    }

    document.querySelectorAll('.selectr-menu-themes').forEach(function (elem) {
        var themesDropdown = new Selectr('#' + elem.id, {
            defaultSelected: false,
            nativeDropdown: false,
            placeholder: elem.getAttribute('placeholder'),
            searchable: true,
            messages: { noResults: 'Geen resultaten', searchPlaceholder: 'Zoek trefwoord...' }
        });
        themesDropdown.on('selectr.open', function () {
            elem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
        themesDropdown.on('selectr.select', function (option) {
            mainNavigationSelectrDropdownSelected(option.value, themesDropdown);
        });
    });
}

function mainNavigationSelectrDropdownSelected(ref, dropdown) {
    var nav = document.getElementById('main-navigation-container');
    if (nav) { nav.classList.remove('visible'); }
    document.body.classList.remove('locked');
    if (dropdown) { dropdown.clear(true); }
    if (ref) {
        var parts = ref.split("?");
        if (document.location.pathname != parts[0]) {
            setTimeout(function () { document.location.href = ref; }, 200);
        } else if (parts[1]) {
            // already on the right page — apply query params without reload
            var params = new URLSearchParams(parts[1]);
            var wijkId = params.get('wijk');
            if (wijkId) {
                var event = new CustomEvent('wijkSelected', { 'detail': { 'wijkId': parseInt(wijkId) } });
                window.dispatchEvent(event);
            }
        }
    }
}

function initTogglePageVisual() {
    var toggleButton = document.getElementById('button-toggle-visual');
    var visual = document.getElementById('page-visual-container');
    var pageContent = document.querySelector('.page-content-wrapper');

    if (!toggleButton) { return; }

    if (hasLocalStorage && localStorage.getItem('showPageVisual') === 'false') {
        toggleButton.classList.add('collapsed');
        if (visual) { visual.classList.add('hidden'); }
        if (pageContent) { pageContent.classList.add('full'); }
    }

    toggleButton.addEventListener('click', function () {
        var hiding = visual && !visual.classList.contains('hidden');
        toggleButton.classList.toggle('collapsed', hiding);
        if (visual) { visual.classList.toggle('hidden', hiding); }
        if (pageContent) { pageContent.classList.toggle('full', hiding); }
        if (hasLocalStorage) { localStorage.setItem('showPageVisual', String(!hiding)); }
    });
}
